import React from 'react'
import ReCAPTCHA from "react-google-recaptcha";

const Form = function form ({form,onChange,onSubmit,recaptchaRefRegister,onChangeCountry,onChangeState,onChangeCity,cities}){
    return (    
        <main>
            <div className="back flex w90">
            <a href={https} className="flex">
                <img src={https+"img/back.svg"} alt="⬅"/>
                <span>Atrás</span>
            </a>
            </div>

            <img src={https+"/img/banner2.jpg"} alt="user-banner" className="userBanner dnone"/>

            <section className="login">
                <div className="container colflex w90">
                    <img src={https+"img/userLog.svg"} alt="🙍‍♂️"/>
                    <h3>
                        Registrarse
                        <br/>
                        <br/>
                    </h3>
                    <form id="formRegister" action="" onSubmit={onSubmit}>
                        <ReCAPTCHA
                            ref={recaptchaRefRegister}
                            size="invisible"
                            sitekey="6LfcjZ0fAAAAAEqsOPo6f6Cmw9e2din9S2TxcM7m"
                        />
                        <input
                            type="text"
                            name="name"
                            placeholder="Nombre"
                            value={form.name}
                            onChange={onChange}
                        />
                        <input
                            type="text"
                            name="lastname"
                            placeholder="Apellido"
                            value={form.lastname}
                            onChange={onChange}
                        />
                        <input 
                            type="text" 
                            placeholder="Ingresa tu Cedula"
                            name="identy"
                            value={form.identy}
                            onChange={onChange}    
                        />
                        <input
                            type="text"
                            name="mail"
                            placeholder="Correo electronico"
                            value={form.mail}
                            onChange={onChange}
                        />
                        <input 
                            type="password" 
                            placeholder="Ingresa tu Contraseña"
                            name="password"
                            value={form.password}
                            onChange={onChange}       
                        />
                        <input
                            type="text"
                            name="phone"
                            placeholder="Teléfono"
                            value={form.phone}
                            onChange={onChange}
                        />
                        <input 
                            type="text" 
                            placeholder="Ingresa tu Direccion"
                            name="address"
                            value={form.address}
                            onChange={onChange}           
                        />
                        <select
                            name="city_id"
                            id="city_id"
                            onChange={onChangeCity}
                        >
                            <option>Selecciona tu Ciudad</option>
                            {cities.map((c) => (
                                <option value={c.CiuCodigo} key={c.CiuCodigo}>{c.CiuNombre}</option>
                            ))}
                        </select>
                        <input 
                            type="text" 
                            placeholder="Ingresa tu Barrio"
                            name="town"
                            value={form.town}
                            onChange={onChange}
                        />
                        <textarea
                            name="description"
                            value={form.description}
                            onChange={onChange}
                            placeholder='Detalles adicionales de la dirrecion...'
                        ></textarea>    
                        <br/>
                        <div className="policy">
                            <p>*Al registrarte autorizas el <a target="_blank" href={https+'terms'}>uso y tratamiento de datos.</a></p>
                        </div>
                        <br/>
                        <button type="submit">
                            Crear mi cuenta
                        </button>
                    </form>
                </div>
            </section>

        </main>
    )
}

export default Form